(() => {
  if (window.nekupiSearchControlsReady) return;
  window.nekupiSearchControlsReady = true;
  document.addEventListener('click', event => {
    const close = event.target.closest('.nk-find-close');
    if (close) {
      const details = close.closest('details');
      details.removeAttribute('open');
      details.querySelector('summary').focus();
      return;
    }
    document.querySelectorAll('.nk-header details[open]').forEach(details => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nk-header details[open]').forEach(details => {
      const restore = details.contains(document.activeElement);
      details.removeAttribute('open');
      if (restore) details.querySelector('summary').focus();
    });
  });
  document.addEventListener('toggle', event => {
    if (!event.target.matches?.('.nk-header details[open]')) return;
    document.querySelectorAll('.nk-header details[open]').forEach(details => {
      if (details !== event.target) details.removeAttribute('open');
    });
  }, true);
})();
